import { ApiService, LoggerFactory, Logger } from '@ibe/services';
import { ApiSeason } from '@ibe/api';
import { computed, makeObservable, observable } from 'mobx';
import { createContext } from 'react';

class SeasonsStore {
  private _logger: Logger = LoggerFactory.get('SeasonsStore');

  private baseApi: ApiService;

  _seasons: ApiSeason[] | null = null;

  constructor() {
    makeObservable(this, {
      _seasons: observable,

      seasons: computed
    });
  }

  setApi(api: ApiService): void {
    this.baseApi = api;
  }

  get seasons(): ApiSeason[] | null {
    return this._seasons;
  }

  async getSeasons(): Promise<Array<ApiSeason>> {
    try {
      const response = await this.baseApi.getSeasons();

      this._seasons = response;
      return response;
    } catch (e) {
      this._logger.warn(e);
      return Promise.reject();
    }
  }
}

export default SeasonsStore;

const seasonsStore = new SeasonsStore();

export const seasonsStoreContext = createContext(seasonsStore);
